<template>
	<v-row align="center" justify="center">
		<v-col cols="12" sm="12" md="12">
			<h1 class="mx-auto white--text text-center">Create a new account</h1>

			<v-stepper value="1" class="mx-auto elevation-0 transparent" style="max-width: 550px">
				<v-stepper-header color="blue">
					<v-stepper-step step="1" color="primary"></v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step step="2" color="secondary"></v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step step="3"></v-stepper-step>
				</v-stepper-header>
			</v-stepper>

			<user-confirm-signup-form></user-confirm-signup-form>
			<br />
			<div class="text-center white--text">
				Already have an account?
				<router-link to="/" class="white--text">Sign In</router-link>
			</div>
		</v-col>
	</v-row>
</template>

<script>
import UserConfirmSignupForm from '@/components/user/UserConfirmSignupForm.vue';

export default {
	name: 'ConfirmSignup',
	components: {
		UserConfirmSignupForm,
	},
	data: () => ({
		apiRequest: false,
	}),
	methods: {},
};
</script>
